import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Action, DefaultPerPageValue, PerPage } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import userImage from "../../assets/images/icons/ticket.png";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { Helmet } from 'react-helmet';
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { getIconPath } from "../../helpers/file_helper";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Search from "../../Components/casp/common/Search";
import { deletePortfolios, getAllPortfolios } from "../../api/casp/portfolio";
import AddPortfolioDrawer from "../../Components/casp/portfolio/addPortfolioDrawer";
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import { withTranslation } from "react-i18next";
import dayjs from "dayjs";

function PortfolioList(props) {
  const [portfolioList, setPortfolioList] = useState([]);
  const [dataColumn, setDataColumn] = useState();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPortfolioRow, setSelectedPortfolioRow] = useState();
  const [action, setAction] = useState();
  const [searchItem, setSearchItem] = useState();
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const hasCreatePermissionForPortfolio = hasModulePermission(Modules.PORTFOLIO, Action.CREATE)
  const hasEditPermissionForPortfolio = hasModulePermission(Modules.PORTFOLIO, Action.EDIT)
  const hasDeletePermissionForPortfolio = hasModulePermission(Modules.PORTFOLIO, Action.DELETE)

  function makeSVG(parent, tag, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs) {
      if (k === "xlink:href") {
        el.setAttributeNS('http://www.w3.org/1999/xlink', 'href', attrs[k]);
      } else {
        el.setAttribute(k, attrs[k]);
      }
    }
  }

  const handleCloseDrawer = async (message) => {
    setIsDrawerOpen(false);
    if (message === "success") {
      setPortfolioList([]);
      if (page > 0) {
        setPage(0);
      } else {
        await fetchPortfolioList(searchItem);
      }
    }

    setSelectedPortfolioRow();
    setAction();
  };

  const handleOpenDrawer = async () => {
    setIsDrawerOpen(true);
  };

  useEffect(() => {
    fetchPortfolioList(searchItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  // console.log(selectedPortfolioRow,'selectedPortfolioRow');


  useEffect(() => {
    if (hasEditPermissionForPortfolio || hasDeletePermissionForPortfolio) {
      setDataColumn([
        {
          field: "index",
          headerName: "#",
          width: 200,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
            </div>
          ),
        },
        // {
        //   field: "uniquePortfolioId",
        //   headerName: props.t("Incubator ID"),
        //   width: 250,
        //   filterable: false,
        //   sortable: false,
        //   renderCell: (params) => (
        //     <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        //       <div className="MuiDataGrid-cellContent">
        //         {params.row?.uniquePortfolioId}
        //       </div>
        //     </div>
        //   ),
        // },
        {
          field: "name",
          headerName: props.t("Name"),
          width: 350,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <div className="MuiDataGrid-cellContent">
                {params.row?.name}
              </div>
            </div>
          ),
        },
        {
          field: "createdAt",
          headerName: props.t("Created Date & Time"),
          width: 250,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <div className="MuiDataGrid-cellContent">
                {dayjs(params.row?.createdAt).format('YYYY-MM-DD HH:MM')}
              </div>
            </div>
          ),
        },
        {
          field: "startDate",
          headerName: props.t("Start Date"),
          width: 250,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <div className="MuiDataGrid-cellContent">
                {params.row?.startDate ? dayjs(params.row?.startDate).format('YYYY-MM-DD') : 'N/A'}
              </div>
            </div>
          ),
        },
        {
          field: "endDate",
          headerName: props.t("End Date"),
          width: 250,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <div className="MuiDataGrid-cellContent">
                {params.row?.endDate ? dayjs(params.row?.endDate).format('YYYY-MM-DD') : 'N/A'}
              </div>
            </div>
          ),
        },
        // {
        //   field: "description",
        //   headerName: props.t("Description"),
        //   width: 250,
        //   filterable: false,
        //   sortable: false,
        //   renderCell: (params) => (
        //     <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        //       <div className="MuiDataGrid-cellContent">
        //         {params.row?.description}
        //       </div>
        //     </div>
        //   ),
        // },
        // {
        //   field: "manager",
        //   headerName: props.t("Manager"),
        //   width: 250,
        //   filterable: false,
        //   sortable: false,
        // },
        {
          field: "actions",
          headerName: props.t("Actions"),
          width: 150,
          sortable: false,
          filterable: false,
          hideable: false,
          renderCell: (params) => (
            <div
              className="proSubmissionActions"
              style={{ display: "flex", alignItems: "center" }}
            >
              {
                hasEditPermissionForPortfolio &&
                <EditOutlinedIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleClick(params.row, Action.EDIT)} />
              }
              {
                hasDeletePermissionForPortfolio &&
                <DeleteOutlineIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsOpenSweetAlert(true);
                    setSelectedPortfolioRow(params.row);
                  }} />
              }
            </div>
          )
        }])
    }

    if (!hasEditPermissionForPortfolio && !hasDeletePermissionForPortfolio) {
      setDataColumn([{
        field: "index",
        headerName: "#",
        width: 200,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
          </div>
        ),
      },
      // {
      //   field: "uniquePortfolioId",
      //   headerName: props.t("Incubator ID"),
      //   width: 250,
      //   filterable: false,
      //   sortable: false,
      //   renderCell: (params) => (
      //     <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      //       <div className="MuiDataGrid-cellContent">
      //         {params.row?.uniquePortfolioId}
      //       </div>
      //     </div>
      //   ),
      // },
      {
        field: "name",
        headerName: props.t("Name"),
        width: 350,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div className="MuiDataGrid-cellContent">
              {params.row?.name}
            </div>
          </div>
        ),
      },
      {
        field: "createdAt",
        headerName: props.t("Created Date & Time"),
        width: 250,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div className="MuiDataGrid-cellContent">
              {dayjs(params.row?.createdAt).format('YYYY-MM-DD HH:MM')}
            </div>
          </div>
        ),
      },
      {
        field: "startDate",
        headerName: props.t("Start Date"),
        width: 250,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div className="MuiDataGrid-cellContent">
              {params.row?.startDate ? dayjs(params.row?.startDate).format('YYYY-MM-DD') : 'N/A'}
            </div>
          </div>
        ),
      },
      {
        field: "endDate",
        headerName: props.t("End Date"),
        width: 250,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div className="MuiDataGrid-cellContent">
              {params.row?.endDate ? dayjs(params.row?.endDate).format('YYYY-MM-DD') : 'N/A'}
            </div>
          </div>
        ),
      },
      ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEditPermissionForPortfolio, hasDeletePermissionForPortfolio, props.t]);

  /** Fetch portfolio list from api */
  const fetchPortfolioList = async (searchItem = "") => {
    try {
      setIsLoading(true);
      let params = {
        page: page + 1,
        perPage: rowsPerPage,
        ...(searchItem && {
          ...searchItem,
        })
      };

      const res = (await getAllPortfolios(params)).data.data;

      // console.log('res', res)
      let level = (page + 1 - 1) * rowsPerPage;
      const resultData = res.data.map((res) => {
        return {
          id: res.id,
          indexNo: ++level,
          uniquePortfolioId: res.uniquePortfolioId,
          name: res.name,
          description: res.description,
          createdAt: res.createdAt,
          startDate: res.startDate,
          endDate: res.endDate,
          projectDeliverables: res.PortfolioDeliverable.map(pd => ({
            id: pd.id,
            deliverableId: pd.deliverable.id,
            name: pd.deliverable.name,
            startDate: pd.startDate,
            endDate: pd.endDate,
          }))
        };
      });

      setPortfolioList(resultData);
      setRowCount(res.meta.total);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
  };

  const handleDelete = async (id) => {
    try {
      setIsLoading(true);
      setIsOpenSweetAlert(false);
      const response = (await deletePortfolios(id)).data;
      toast.success(response.message);
      setIsLoading(false);
      setPortfolioList([]);
      if (page > 0) {
        setPage(0);
      } else {
        await fetchPortfolioList(searchItem);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
    }
  };

  const handleClick = async (params, action) => {
    setIsDrawerOpen(true);
    setSelectedPortfolioRow(params);
    setAction(action);
  };

  const globalSearch = async (params) => {
    setPortfolioList([]);
    page > 0 ? setPage(0) : fetchPortfolioList(params);
  };

  const getRowId = (row) => row.id;

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, 'linkTags', []), {
                rel: 'icon',
              })

              if (!newFaviconElems.length) {
                return
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              )

              if (existingFavicons.length) {
                existingFavicons.forEach(e => e.parentNode.removeChild(e))
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              )
              const iconToShow = <ManageAccountsIcon />
              //<i className={'ri-git-pull-request-line'}></i>

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true)
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(iconToShow)}</svg>`
                )}`
                const parentElem = newFaviconElem.parentNode
                parentElem.removeChild(newFaviconElem)
                parentElem.appendChild(newFavElement)
              }
            } catch (e) {
              console.error(e)
            }
          }}
        >
          <title>{props.t('Cohort List')}</title>
        </Helmet>
        <Container fluid>
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={props.t("Cohort List")} />

            {/* <TextField id="outlined-basic" label="Outlined" variant="outlined" placeholder="Search..." /> */}
            <div className="d-flex">
              <div className="filterTitle d-flex align-items-center mx-2 taskHeaderSearchField">
                <Search listCall={globalSearch} />
              </div>
              {
                hasCreatePermissionForPortfolio &&
                <button
                  className="edit_button d-flex justify-content-center px-3"
                  onClick={handleOpenDrawer}
                >
                  <p className="mb-0">{props.t("Add Cohort")}</p>
                </button>
              }
            </div>
          </div>
          <div className="projectTypeTable my-4" style={{ height: '500px' }}>
            {portfolioList.length > 0 && (
              <DataGrid
                rows={portfolioList}
                columns={dataColumn}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
              />
            )}
            {portfolioList.length === 0 && isLoading && <Loader />}
            {portfolioList.length === 0 && !isLoading && (
              <NodataFound text={props.t("No portfolios to show")} icon={userImage} />
            )}
          </div>
        </Container>
        <AddPortfolioDrawer
          isOpen={isDrawerOpen}
          handleClose={handleCloseDrawer}
          action={action}
          selectedPortfolioRow={selectedPortfolioRow}
        />

        {isOpenSweetAlert && (
          <SweetAlert
            title={props.t("Are you sure you want to delete this cohort?")}
            warning
            showCancel
            confirmBtnText={props.t("OK")}
            cancelBtnText={props.t("Cancel")}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={async () => {
              await handleDelete(selectedPortfolioRow.id);
            }}
            onCancel={() => {
              setIsOpenSweetAlert(false);
            }}
          ></SweetAlert>
        )}
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(PortfolioList)
